'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('justifyContent', 'justify');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/justify-content.js
// module id = 381
// module chunks = 168707334958949